
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Tooltip,
  Position,
  Button,
  Category,
  Dot,
  Flex,
  FlexItem,
  Size,
  Margin,
  Icon,
  ListTile,
  Text,
  Color,
} from '@drawbotics/react-drylus';
import sv from '@drawbotics/drylus-style-vars';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Tooltip`}</h1>
<p>{`It can be used to wrap any component/element and display a hint when hovered. The component is uncontrolled and uses portals to be rendered on top of the content.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Tooltip } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Flex>
  <FlexItem>
    <Margin size={{ right: Size.LARGE }}>
      <Tooltip content="I am a tooltip">
        <Button category={Category.BRAND}>Hover me</Button>
      </Tooltip>
    </Margin>
  </FlexItem>
  <FlexItem>
    <Tooltip
      content={
        <div style={{ textAlign: 'left' }}>
          <Margin size={{ bottom: Size.EXTRA_SMALL }}>
            <ListTile leading={<Icon name="alert-triangle" color={Color.RED} />} title={<Text inversed size={Size.SMALL}>I'm custom content</Text>} />
          </Margin>
          <ListTile leading={<Icon name="check-circle" color={Color.GREEN} />} title={<Text inversed size={Size.SMALL}>So am I</Text>} />
        </div>
      }>
      <Dot color={Color.GREEN} />
    </Tooltip>
  </FlexItem>
</Flex>`} component={Tooltip} mdxType="Playground">
  <Flex mdxType="Flex">
    <FlexItem mdxType="FlexItem">
      <Margin size={{
            right: Size.LARGE
          }} mdxType="Margin">
        <Tooltip content="I am a tooltip" mdxType="Tooltip">
          <Button category={Category.BRAND} mdxType="Button">Hover me</Button>
        </Tooltip>
      </Margin>
    </FlexItem>
    <FlexItem mdxType="FlexItem">
      <Tooltip content={<div style={{
            textAlign: 'left'
          }}>
            <Margin size={{
              bottom: Size.EXTRA_SMALL
            }} mdxType="Margin">
              <ListTile leading={<Icon name="alert-triangle" color={Color.RED} mdxType="Icon" />} title={<Text inversed size={Size.SMALL} mdxType="Text">I'm custom content</Text>} mdxType="ListTile" />
            </Margin>
            <ListTile leading={<Icon name="check-circle" color={Color.GREEN} mdxType="Icon" />} title={<Text inversed size={Size.SMALL} mdxType="Text">So am I</Text>} mdxType="ListTile" />
          </div>} mdxType="Tooltip">
        <Dot color={Color.GREEN} mdxType="Dot" />
      </Tooltip>
    </FlexItem>
  </Flex>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;